import { NgModule } from '@angular/core';
import { ZefDialogModule } from '@zerops/zef/dialog';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { CommonModule } from '@angular/common';
import { ClientUserRoleDialogContainer } from './client-user-role-dialog.container';
import { ZefScrollbarComponent } from '@zerops/zef/scrollbar';
import { MatIconModule } from '@angular/material/icon';
import { EffectsModule } from '@ngrx/effects';
import { ClientUserRoleDialogEffect } from './client-user-role-dialog.effect';


@NgModule({
  declarations: [ ClientUserRoleDialogContainer ],
  imports: [
    CommonModule,
    EffectsModule.forFeature([ ClientUserRoleDialogEffect ]),
    ZefDialogModule,
    MatLegacyButtonModule,
    MatLegacyFormFieldModule,
    MatLegacyInputModule,
    ZefScrollbarComponent,
    MatIconModule
  ],
  exports: [ ClientUserRoleDialogContainer ]
})
export class ClientUserRoleDialogModule {}
